"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// grayscale - lightest to darkest
exports.WHITE = '#FFFFFF';
exports.KARL = '#F4F6F5';
exports.NEVADA = '#5E676B';
exports.MAKO = '#444D52';
exports.SPACE = '#33393D';
// http://chir.ag/projects/name-that-color/
// colors - rainbow sort
exports.BONDI = '#0091BB';
exports.REGENT = '#CBE8F5';
exports.DANDELION = '#FFD966';



// WEBPACK FOOTER //
// ./src/components/styled/Colors.ts